import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { getQueryParam } from 'src/lib/utils';
import { RoundedButton } from '../shared/buttons/RoundedButton';
import { reveal } from '../shared/keyframe-animations';
import { Logo } from '../shared/Logo';

const WalkthroughFirstStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 0 7vh;
  h1,
  .logo,
  .desc,
  .button {
    opacity: 0;
    animation: 0.4s ease-in-out ${reveal} both;
    @media (prefers-reduced-motion: reduce) {
      animation-delay: -1ms !important;
      animation-duration: 1ms;
      animation-iteration-count: 1;
    }
  }
  h1 {
    font-size: calc(2vh + 8px);
    margin-top: 52px;
    padding: 0 24px;
    transform: translateY(4px);
    animation-delay: 0.2s;
  }
  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 320px;
    height: 24vh;
    transform: translateY(4px);
    animation-delay: 0.4s;
  }
  .desc {
    margin: 0 24px;
    transform: translateY(4px);
    animation-delay: 0.8s;
    z-index: 1;
    @media (max-width: 370px) {
      font-size: 14px;
    }
  }
  .space {
    flex: 1 1 auto;
  }
  img {
    width: 70%;
    height: 70%;
  }
  .button {
    width: 100%;
    padding: 0 24px;
    z-index: 1;
    animation-delay: 1.2s;
    visibility: hidden;
  }
`;

export const WalkthroughFirst: React.FC = () => {
  const { t } = useTranslation('translation');
  const history = useHistory();
  const location = useLocation();
  const raid = getQueryParam(location.search, 'raid');
  const handleButtonClick = useCallback(() => {
    const dest = raid ? `/walkthrough/2?raid=${raid}` : '/walkthrough/2';
    history.replace(dest);
  }, [history, raid]);

  return (
    <section className={WalkthroughFirstStyles}>
      <h1>{t('tutorial')}</h1>
      <div className="logo">
        <Logo scale={1.3} />
      </div>
      <p className="desc">{t('tutorial_00')}</p>
      <div className="space" />
      <div className="button">
        <RoundedButton color="white" background="#14c5b6" onClick={handleButtonClick}>
          {t('tutorial_01')}
        </RoundedButton>
      </div>
    </section>
  );
};
